/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, Suspense } from "react"

import { Paper, TableRow, TableCell } from "@material-ui/core"

import { stableSort, getComparator } from "App/Component/ui/datatable/utils"

import {
  DatatablesFooterServerSide,
  Title,
  TableCellDefault,
  Loading,
  ModalDeleteConfirm,
  TableAction,
} from "App/Component/ui"

import {
  STYLE_DEFAULT_MASTER,
  BILLING_INPUT_PENJUALAN,
  BILLING_DAFTAR_PENJUALAN,
} from "App/constants"

import {
  useDatatablesServerSide,
  useDatatables,
  useLocalStorageForm,
} from "App/hooks"
import {
  getByFilterPenjualan,
  headCells,
  RESET_STATE_FORM_FILTER,
  deleteByID,
  RESET_STATE_FORM_FILTER_EXTERNAL,
  RenderStatusPembelian,
  RenderStatusJurnal,
  getDataEditPenjualan,
} from "./helpers"
import {
  defaultDateDisplay,
  defaultToastError,
  formatNumber,
  defaultToastSuccess,
  tipePembayaranName,
} from "App/utils/helpers"

import FormFilterDaftarPenjualan from "./FormFilterDaftarPenjualan"
import { FreezeTable } from "components/organism"
import { useDispatchWrapper } from "hooks"
import {
  changeActiveMenu,
  changeActiveTab,
  changePagePropsInputPenjualan,
} from "../../Wrapper/context/actions"
import { LoadingBackdrop } from "components/atoms"
import useMutationDiskon from "../InputPenjualan/ui/hooks/useMutationDiskon"

export default function DaftarPenjualan() {
  const classes = STYLE_DEFAULT_MASTER()
  const [loading, setLoading] = useState(false)

  /**
   * Jika merubah handleClickUpdate maka harus merubah di input tagihan/tab penjualan juga
   */
  const { dispatch, handleClickMenu } = useDispatchWrapper()

  const { getDiskon } = useMutationDiskon()
  const handleClickUpdate = async (row) => {
    setLoading(true)
    const diskon = await getDiskon(row.id_type_of_care, row.insurance_id)

    Promise.resolve()
      .then(() => {
        dispatch(changeActiveMenu(BILLING_INPUT_PENJUALAN))
      })
      .then(async () => {
        const propsPageInputPenjualan = await getDataEditPenjualan(
          row,
          "tagihanIdKunj",
          diskon,
        )

        dispatch(changePagePropsInputPenjualan(propsPageInputPenjualan))
        dispatch(changeActiveTab(BILLING_INPUT_PENJUALAN))

        handleClickMenu({
          code: BILLING_INPUT_PENJUALAN,
          name: "Input Penjualan",
        })

        setLoading(false)
      })
  }

  return (
    <Suspense fallback={<LoadingBackdrop />}>
      <div className={classes.root}>
        <Title title={"Daftar Penjualan"} />
        <RenderContentDaftarPenjualan
          handleClickUpdate={handleClickUpdate}
          classes={classes}
          loading={loading}
          setLoading={setLoading}
        />
      </div>
    </Suspense>
  )
}

export const RenderContentDaftarPenjualan = ({
  handleClickUpdate,
  classes,
  loading,
  setLoading,
  onlyExternal = false,
  isSelect = false,
  alwaysLunas = false,
}) => {
  const [rows, setRows] = useState([])
  const [formFilter, setFormFilter] = useLocalStorageForm(
    onlyExternal ? RESET_STATE_FORM_FILTER_EXTERNAL : RESET_STATE_FORM_FILTER,
    BILLING_DAFTAR_PENJUALAN,
  )
  const [totalData, setTotalData] = useState(0)
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)
  const [penjualanID, setPenjualanID] = useState()

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
  ) => {
    setLoading(true)

    const res = await getByFilterPenjualan(
      formFilter,
      pages,
      limit,
      alwaysLunas,
    )
    if (res.state) {
      setRows(res.data)
      setTotalData(res.meta.count)
      setLoading(false)
    } else {
      setRows([])
      setLoading(false)
      defaultToastError(res.message)
    }
  }

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = useDatatablesServerSide({ setNewData: setNewData })

  useEffect(() => {
    ;(async () => {
      await setNewData()
    })()
  }, [])

  const handleClickDelete = (row) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
    setPenjualanID(row.id)
  }

  async function deleteList() {
    const res = await deleteByID(penjualanID)

    if (res.state) {
      defaultToastSuccess(res.message)
      setNewData()
    } else {
      defaultToastError(res.message)
    }

    setShowModalDeleteConfirm(false)
  }

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <Paper
        className={classes.paper}
        style={{
          padding: "1rem",
        }}
      >
        <FormFilterDaftarPenjualan
          formFilter={formFilter}
          setFormFilter={setFormFilter}
          setNewData={setNewData}
          withExportButton
          alwaysLunas={alwaysLunas}
          resetPagination={resetPagination}
        />
        <Loading show={loading} />
        <div className="mt-1">
          <TableDaftarPenjualan
            rows={rows}
            clickUpdate={handleClickUpdate}
            clickDelete={handleClickDelete}
            onlyExternal={onlyExternal}
            isSelect={isSelect}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </div>
      </Paper>
    </>
  )
}

const TableDaftarPenjualan = ({
  rows,
  clickUpdate,
  clickDelete,
  onlyExternal,
  isSelect,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id", "tagihanIdKunj", "tagihanIdExt"],
  })

  const Action = ({ row }) => {
    if (isSelect) {
      return (
        <>
          <TableAction
            isUpdate={false}
            isDelete={false}
            isSelect={true}
            clickSelect={() => clickUpdate(row)}
          />
        </>
      )
    } else {
      return (
        <TableAction
          clickDelete={() => clickDelete(row)}
          clickUpdate={() => clickUpdate(row)}
        />
      )
    }
  }

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow hover key={index}>
            <TableCell align="center">{index + 1}</TableCell>
            <TableCell align="center">
              {onlyExternal ? (
                <TableAction
                  isUpdate={false}
                  isDelete={false}
                  isSelect={true}
                  clickSelect={() => clickUpdate(row)}
                />
              ) : (
                <Action row={row} />
              )}
            </TableCell>
            <TableCell align="left">{row?.id}</TableCell>
            <TableCell align="left">{row?.IDGL}</TableCell>
            <TableCell align="left">{row?.id_kunjungan}</TableCell>
            <TableCell align="left">
              {row.isExternal === 1 ? row.tagihanIdExt : row.tagihanIdKunj}
            </TableCell>
            <TableCell align="left">
              {row.isExternal === 1 ? row.rm_id : row.id_rm}
            </TableCell>
            <TableCell align="left">{row?.nama_rm}</TableCell>
            <TableCell align="left">{defaultDateDisplay(row?.date)}</TableCell>
            <TableCell align="left">
              {/* {row.bayar_jual >= row.total_Penjualan ? "Lunas" : "Belum Lunas"} */}
              {row.status_lunas}
            </TableCell>
            <TableCell align="center">
              <RenderStatusPembelian status={row.status_transaksi} />
            </TableCell>
            <TableCell align="left">
              <RenderStatusJurnal status={row.is_jurnal} />
            </TableCell>
            <TableCell align="left">{row?.namaDokter}</TableCell>
            <TableCell align="left">{row?.nama_poliklinik}</TableCell>
            <TableCell align="left">{row?.jenis_layanan_name}</TableCell>
            <TableCell align="left">{row?.namaGudang}</TableCell>
            <TableCell align="left">{row?.namaAsuransi}</TableCell>
            <TableCell align="left">
              {tipePembayaranName(row.msTipePembayaranId)}
            </TableCell>
            <TableCell align="right">
              {formatNumber(row?.harga_total_barang)}
            </TableCell>
            <TableCell align="right">
              {formatNumber(row?.harga_total_jasa)}
            </TableCell>
            <TableCell align="right">
              {formatNumber(row?.harga_total_fasilitas)}
            </TableCell>
            <TableCell align="right">
              {formatNumber(row?.harga_total_rikjang)}
            </TableCell>
            <TableCell align="right">
              {formatNumber(row?.harga_total_paket)}
            </TableCell>
            <TableCell align="right">{formatNumber(row.jumlah_tax)}</TableCell>
            <TableCell align="right">
              {formatNumber(row.jumlah_set_discount)}
            </TableCell>
            <TableCell align="right">
              {formatNumber(row.total_Penjualan)}
            </TableCell>
            <TableCellDefault row={row} />
          </TableRow>
        )
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align="center" colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  )
}
